import React, { useEffect, useState } from 'react'
import { useMutation, useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { CANCELOFFER_API, CDR_SETTINGS, POSTPAIDBALANCE_API, PREPAIDRENEWALCONTROLAPI } from '../../services/common/endpoints';
import Loadingcomponent from '../loader/loadingcomponent';
import { getImgSrc, getformatedMsisdn } from '../../services/common/CommonUtils';
import { callQueryapi } from '../../services/http/callapi';
import CommonModalComponent from '../common/common-modal';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation, Thumbs } from 'swiper';
import {
    isContainAlphabet,
    setItemInSessionStorage
  } from "../../services/common/utils";
import ConfirmationModal from './confirmation-modal';
import MessageModal from '../cdr/subscriptionDialog';
import CurrentPackData from '../loader/skeletons/current-pack-data';
import { setCdrCards, setCdrSettings, setCdrtransid, setIsCdrCardsData, setIsVip } from '../../reducer/cdrSlice';
import ViewcallHistoryButton from './viewcallHistoryButton';
function CurrentPack({ isUsageData }) {
    const navigate = useNavigate();
    const customerprofile = useSelector(
        (state) => state.userdata.value.customerprofile
    );
    const isPostpaid = customerprofile?.RatePlanType === "POSTPAID";
    const [viewCallHistory, setViewCallHistory] = useState('');
    const [viewCallHistoryIcon, setViewCallHistoryIcon] = useState('');
    const [isVipCheck, setIsVipCheck] = useState('');
    const switchedMsisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);
    const loggedInMsisdn = localStorage.getItem('sl');
    const isMsisdnSwitched = switchedMsisdn === loggedInMsisdn ? false : true;
    const msisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);
    const dispatch = useDispatch();
    const promoApi = useQuery(
        ['promo_details', POSTPAIDBALANCE_API, { msisdn: '', type: 'promo' }, {}],
        {
            enabled: isPostpaid,
            retry: false,
        }
    );
    let isCdrRedirect = localStorage.getItem("cdr") === "true";

    // const handleViewCallHistoryCheck = () =>{
    //     let isHeLogin = localStorage.getItem("ihe"); 
    //     if(!isHeLogin){
    //         if(customerprofile?.CustomerType === "B2C"){
    //             return true       // customerType B2C
    //         }else if(customerprofile?.CustomerType == 'B2B' && customerprofile?.PaymentResponsible == 'X'){
    //             return true      //customertype B2B EPR
    //         }else{
    //             return false     // not B2BEPR  or B2C
    //         }
    //     }else{
    //       return  false  // he login case
    //     }
    // }

    const settingsApi = useQuery(['cdr-settings', CDR_SETTINGS, {},{}, false, 'cdr'],
    {
        enabled: true,
        retry: false,
        onSuccess:({data: settingsApiData})=>{
            if(settingsApiData?.status === '0'){
                setIsVipCheck(settingsApiData?.response?.commonconfigurations?.enable_vip_simulation && settingsApiData?.response?.commonconfigurations?.vip_simulator_numbers?.indexOf(msisdn) > -1);
                dispatch(setCdrSettings(settingsApiData?.response));
                setViewCallHistory(settingsApiData?.response?.commonconfigurations?.view_call_history);
                setViewCallHistoryIcon(settingsApiData?.response?.commonconfigurations?.view_call_history_icon)
            }
        }
    })

    useEffect(()=>{
        try{
        if(customerprofile && settingsApi?.data){
            let vipStatus = (isVipCheck === 'T' || customerprofile?.vipstatus === "Y")
            dispatch(setIsVip(vipStatus));
            const VipData = {
                vipStatus : vipStatus ? "true" : false,
                "vip_bg_color": settingsApi?.data?.data?.response?.commonconfigurations?.vip_bg_color,
                "vip_text_color": settingsApi?.data?.data?.response?.commonconfigurations?.vip_text_color
            }
            setItemInSessionStorage("isVip", JSON.stringify(VipData));
        }
        }catch{}
    }, [customerprofile, settingsApi])

    const {data: {data}={}, isLoading, isFetching} = useQuery(['cdrCardspack', "cdr/getjson", {"catg":"cdrcards" }, {}, false, 'cdr'],
    {
        enabled: isCdrRedirect,
        onSuccess:({data: udata})=>{
            if(udata?.status === '0'){
                if(udata?.data){
                }else{
                dispatch(setIsCdrCardsData(udata?.data));
                dispatch(setCdrtransid(udata.response));
                navigate("/verification");
                }
                if(udata?.response && udata?.response?.cards){
                    dispatch(setCdrCards(udata?.response?.cards));  
                }
            }
        }
    })
  
    const currentPack = useQuery(['current-pack', PREPAIDRENEWALCONTROLAPI, {}, {}], {
        enabled: !isPostpaid,
        cacheTime: 0,
    });

    const handleScroll = (e) => {
        if (e) {
            e?.preventDefault();
        }

        if(!isUsageData){
            let sectionToScroll;
            let adjustedPx;
            if(document.getElementById('packsAndSub')){
                sectionToScroll = document.getElementById('packsAndSub');
                adjustedPx = 100;
            }else{
                sectionToScroll = document.getElementById('noViewUsage');
                adjustedPx = 340;
            }
            let position = sectionToScroll.getBoundingClientRect();
            window.scrollTo({
                top: position.top + window.scrollY - adjustedPx,
                left: position.left,
                behavior: "smooth",
            }); 
        }else{
            const sectionToScroll = document.getElementById('viewUsage');
            let position = sectionToScroll.getBoundingClientRect();
            window.scrollTo({
                top: position.top + window.scrollY - 100,
                left: position.left,
                behavior: "smooth",
            });
        }
    }

    if (promoApi.isLoading || currentPack.isLoading) {
        // return <Loadingcomponent />
        return <CurrentPackData isPostpaid={isPostpaid} />
    }

    const promoData = promoApi?.data?.data?.response;
    const currentPackData = currentPack?.data?.data?.response;

    if(isPostpaid){
        if (
            !promoApi?.data?.data?.response ||
            promoApi?.data?.data?.status === '-1'
          ) {
            return <></>;
          }
    }

    if(!isPostpaid){
        if (
            !currentPack?.data?.data?.response ||
            currentPack?.data?.data?.status === '-1'
          ) {
            return <></>;
          }
    }

    if (isPostpaid) {
        return <PostpaidView promoData={promoData} customerprofile={customerprofile} handleScroll={handleScroll} 
        viewCallHistory={viewCallHistory} 
        viewCallHistoryIcon={viewCallHistoryIcon} 
        isVipCheck={isVipCheck}
        // handleViewCallHistoryCheck={handleViewCallHistoryCheck}
        cdrLoading={settingsApi?.isLoading || settingsApi?.isFetching}
        isMsisdnSwitched={isMsisdnSwitched}
      
        />
    } else {
        return <TabView currentPackData={currentPackData} handleScroll={handleScroll} 
        viewCallHistory={viewCallHistory} 
        viewCallHistoryIcon={viewCallHistoryIcon} 
        // handleViewCallHistoryCheck={handleViewCallHistoryCheck}
        cdrLoading={settingsApi?.isLoading || settingsApi?.isFetching}
        isVipCheck={isVipCheck}
        isMsisdnSwitched={isMsisdnSwitched}
      
        />
    }
}

function PostpaidView({ promoData, customerprofile, handleScroll , viewCallHistory, viewCallHistoryIcon, cdrLoading, isVipCheck, isMsisdnSwitched}) {
    const { t } = useTranslation();
    const Msisdn = getformatedMsisdn(customerprofile?.Msisdn);
    const navigate = useNavigate();
   
    return <div class="white_card dashboard_card sprint14-blance-info2 mt-30">
        <div>
            <div class="balance_section_info">
                <div className='d-flex'>
                <label className='me-3'>{promoData?.currentpacklabel || ''}</label>
                <label>{Msisdn}</label>
                </div>
                
                <h5> {promoData?.WbbService || ""} </h5>
                <div class="sprint14-pack-active">
                    <label> {promoData.activelabel || ''} </label> {promoData?.CommitmentExpiry ? `${`${promoData?.expireonlabel}:` || ''} ${promoData?.CommitmentExpiry || ''}` : ''}
                </div>
                <hr />
                <div class="d-flex align-items-center sprint14-blance-row mt-2">
                    <div class="sprint14-blance-col d-flex align-items-center justify-content-between">
                        <label>{promoData?.WbbServicelabel}</label>
                        <div> : </div>
                    </div>
                    <div>{promoData?.WbbService || ""}</div>
                </div>
                <div class="d-flex align-items-center sprint14-blance-row mt-2">
                    <div class="sprint14-blance-col d-flex align-items-center justify-content-between">
                        <label>{promoData?.promolabel}</label>
                        <div> : </div>
                    </div>
                    <div>{promoData?.Promo || ""}</div>
                </div>
                <div class="d-flex align-items-center sprint14-blance-row mt-2">
                    <div class="sprint14-blance-col d-flex align-items-center justify-content-between">
                        <label>{promoData?.CommitmentStartlabel}</label>
                        <div> : </div>
                    </div>
                    <div>{promoData?.CommitmentStart || ""}</div>
                </div>
                <div class="d-flex align-items-center sprint14-blance-row mt-2">
                    <div class="sprint14-blance-col d-flex align-items-center justify-content-between">
                        <label>{promoData?.CommitmentExpirylabel}</label>
                        <div> : </div>
                    </div>
                    <div>{promoData?.CommitmentExpiry || ""}</div>
                </div>
            </div>
             {/* <hr />  // view call history text addition */}
            <div class="d-flex justify-content-between align-item-center">

                <div class="balance_section_action align-self-center">
                    {/* <button class="custom_btn custom_btn_sm custom_btn_primary">Upgrade Plan</button> */}
                </div>

                <div>
                    <a class="hyperlink" href='#' onClick={handleScroll}>
                        {promoData?.BtnViewusage}
                        <img src={getImgSrc('/assets/images/right_arrow_red.svg')} class="ms-1" alt="arrow" />
                    </a>
                </div>

            </div>
        </div>
        { promoData?.enablecdr && 
        <ViewcallHistoryButton viewCallHistory={viewCallHistory} viewCallHistoryIcon={viewCallHistoryIcon} cdrLoading={cdrLoading} isVipCheck={isVipCheck}/>
        }
    </div>
}

function TabView({ currentPackData, handleScroll , viewCallHistory, viewCallHistoryIcon, isVipCheck, cdrLoading, isMsisdnSwitched}) {
    const navigate = useNavigate();
    const [popupShow, setPopupShow] = useState(false);
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [showCenterModal, setShowCenterModal] = useState(false);
    const customerprofile = useSelector(
        (state) => state.userdata.value.customerprofile
    );
    const onOffTogglePacks = () => {
        const params = {
            offerid: currentPackData?.nextrenewalpackid,
            isimmediatecancel: '0',
            isstopfallbackpurchase: '0',
        };
        packToggleOnOff.mutate(params);
    };

    const packToggleOnOff = useMutation(
        (req) =>
            callQueryapi({
                queryKey: [{}, CANCELOFFER_API, req],
            }),
        {
            onSuccess: async (udata) => {
            const status = udata?.data?.status;
            try {
            const infomsg = udata?.data?.infomsg;
            const message = udata?.data?.message;
            if (status === "0") {
            navigate("/transactionstatus", {
            state: { isoffline: true, isuccess: true, info_message: infomsg, message: message },
            });
            } else {
            navigate("/transactionstatus", {
            state: { isoffline: true, isuccess: false, info_message: infomsg, message: message },
            });
            }
                } catch (e) {
            navigate("/transactionstatus", {
            state: { isoffline: true, isuccess: false, info_message: "", message: "" },
            });
            }
            },
            onError: () => {
                navigate("/transactionstatus", {
                    state: { isoffline: true, isuccess: false, info_message: "", message: "" },
                });
            },
        }
    );

    const handleToggle = () =>{
        setShowCenterModal(!showCenterModal);
    }
    const handleUnscuscribe = () => {
        setPopupShow(true);
    }

    const toggleModal = () => {
        if(packToggleOnOff?.isLoading){
            return;
        }
        
        setPopupShow(!popupShow);
    };

    const handleChangePlan = () => {
        if(currentPackData?.changeplan_deeplink === 'changeplan'){
            navigate('/bundles', {
                state: {
                    isChangePlan: true,
                }
            });
        }
    }

    const handleBuyPlan = () => {
        if(currentPackData?.buybundle_deeplink === 'buybundle'){
            navigate('/bundles', {
                state: {
                    isBuyPlan: true,
                }
            });
        }
    }

    return <>
        <div class="white_card dashboard_card mt-30">
            <div class="flex_grp_between">
                <div class="tabs-comp-two">
                    <section class="corp-abt-thumb-slider pack-tab-swiper-two sprint14-pack-tabs">
                        <div class="position-relative category-tabs">
                            <div class="container-tab position-relative">
                                <Swiper
                                    className="swiper-container tabs-thumbs c-about-thumbs gap-4"
                                    modules={[FreeMode, Navigation, Thumbs]}
                                    onSwiper={setThumbsSwiper}
                                    freeMode={true}
                                    watchSlidesProgress={true}
                                    spaceBetween={0}
                                    slidesPerView={3}
                                    observer={true}
                                    observeParents={true}
                                >
                                    <SwiperSlide className='w-50'>
                                        <p class="year-cont">{currentPackData?.currentpacklabel}</p>
                                    </SwiperSlide>
                                    {currentPackData?.isnextrenewal == 'true'
                                        ? (
                                            <SwiperSlide className='w-50'>
                                                <p class="year-cont">{currentPackData.scheduledpacklabel}</p>
                                            </SwiperSlide>
                                        )
                                        : <SwiperSlide className='w-50'>
                                            <p class="year-cont">{currentPackData.noscheduledpacklabel}</p>
                                        </SwiperSlide>
                                    }

                                </Swiper>
                            </div>
                        </div>

                        <Swiper
                            className="swiper-container tabs-top-swiper container p-0"
                            modules={[FreeMode, Navigation, Thumbs]}
                            thumbs={{ swiper: thumbsSwiper }}
                            observer={true}
                            observeParents={true}
                            spaceBetween={10}
                            navigation={{
                                nextEl: '.swipertabs-button-next',
                                prevEl: '.swipertabs-button-prev',
                            }}
                        >
                            <SwiperSlide>
                                <section class="">
                                    <div class="align-items-center justify-content-between sprint14-currentpack-tab" >
                                        <div class="d-flex align-items-center justify-content-between" >
                                            <div class="current-pack-lr" > <h4> {currentPackData?.currenpack} </h4> </div>
                                            <div class="current-pack-rl view-more-btn pointer" onClick={handleScroll}>
                                                 {/* {currentPackData?.btntext} 
                                                 <img src={getImgSrc('/assets/images/right_arrow_red.svg')}
                                                 alt="arrow" class="right-arrow" />  */}

                                                 {/* before */}
                                                 {/* <a class="hyperlink" href="#">{currentPackData?.btntext} 
                                                 <img src={getImgSrc('/assets/images/right_arrow_red.svg')} class="ms-1" alt="arrow"></img></a> */}

                                                 {/* sprint 16 */}
                                                 {
                                                  currentPackData?.buybundle ? <button class="custom_btn custom_btn_sm custom_btn_primary sp16_custom_btn" onClick={handleBuyPlan}>{currentPackData?.buybundle_buttontext}</button> : <a class="hyperlink" href="#">{currentPackData?.btntext} 
                                                   <img src={getImgSrc('/assets/images/right_arrow_red.svg')} class="ms-1" alt="arrow"></img></a>
                                                 }
                                                 </div>
                                        </div>
                                        <div class="pack-active-row">
                                            <label>{currentPackData?.activelabel}</label>
                                            {currentPackData?.currentpackexpiry && (
                                                <>{currentPackData?.curretnpackexpirylabel}: {currentPackData?.currentpackexpiry}</>
                                            )}
                                            <div class="d-flex align-items-center">
                                                {
                                                    currentPackData?.currentpackexpirytime && (
                                                        <img src={getImgSrc(currentPackData?.timericon, true)} alt="timer-icon" />
                                                    )
                                                }
                                                <span style={{"direction":isContainAlphabet(currentPackData?.nextrenewaltime) ? "ltr" :""}}> {currentPackData?.currentpackexpirytime} </span>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    {/* view call history */}
                                    {currentPackData?.enablecdr &&
                                   <ViewcallHistoryButton viewCallHistory={viewCallHistory} viewCallHistoryIcon={viewCallHistoryIcon} cdrLoading={cdrLoading} isVipCheck={isVipCheck}/>}
                                </section>
                            </SwiperSlide>

                            {currentPackData?.isnextrenewal == 'true'
                                        ? ( <>
                                         <SwiperSlide>
                                <section class="">
                                    <div class="align-items-center justify-content-between sprint14-currentpack-tab">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <div class="current-pack-lr"> <h4> {currentPackData?.nextrenewalpack} </h4> </div>
                                            <div class="current-pack-rl">
                                                {/* before */}
                                                {/* {
                                                    currentPackData?.showunsub === 'true' && (
                                                        <button class="custom_btn custom_btn_sm custom_btn_primary" onClick={handleUnscuscribe}>{currentPackData?.unsubscribelabel}</button>
                                                    )
                                                } */}

                                                {/* sprint-16 */}
                                                {
                                                    currentPackData?.changeplan ? <button class="custom_btn custom_btn_sm custom_btn_primary sp16_custom_btn" onClick={handleChangePlan}>{currentPackData?.changeplan_buttontext}</button> : (
                                                        <>
                                                            {
                                                                currentPackData?.showunsub === 'true' && (
                                                                    <button class="custom_btn custom_btn_sm custom_btn_primary" onClick={handleUnscuscribe}>{currentPackData?.unsubscribelabel}</button>
                                                                )
                                                            }
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                        <div class="pack-active-row">
                                            <label> {currentPackData?.scheduledlabel} </label> 
                                            {currentPackData?.currentpackexpiry && (
                                                <>{currentPackData?.changeplan ? currentPackData?.renewdatelabel : currentPackData?.curretnpackexpirylabel}: {currentPackData?.currentpackexpiry}</>
                                            )}
                                            <div class="d-flex align-items-center">
                                                {
                                                    currentPackData?.nextrenewaltime && (

                                                        <img src={getImgSrc(currentPackData?.timericon, true)} alt="timer-icon" />
                                                    )
                                                }
                                                <span style={{"direction":isContainAlphabet(currentPackData?.nextrenewaltime) ? "ltr" :""}}> {currentPackData?.nextrenewaltime} </span>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </SwiperSlide>
                                        </>) :(<></>)
                            }

                           
                        </Swiper>

                    </section>

                    

                </div>
            </div>
        </div>

        {/* <CommonModalComponent
            title={
                currentPackData?.popupinfo?.title
            }
            description={currentPackData?.popupinfo?.description}
            cancelText={currentPackData?.popupinfo?.btnclosetext}
            show={popupShow}
            submitText={currentPackData?.popupinfo?.btnunsubtext}
            toggleModal={() => {
                toggleModal();
            }}
            submit={onOffTogglePacks}
            loading={packToggleOnOff?.isLoading}
            success={packToggleOnOff?.isSuccess}
        /> */}

        <ConfirmationModal
            title={currentPackData?.popupinfo?.title}
            description={currentPackData?.popupinfo?.description}
            cancelText={currentPackData?.popupinfo?.btnclosetext}
            show={popupShow}
            submitText={currentPackData?.popupinfo?.btnunsubtext}
            toggleModal={() => {
                toggleModal();
            }}
            submit={onOffTogglePacks}
            loading={packToggleOnOff?.isLoading}
        />
    </>
}

export default CurrentPack;